export const ADMIN_BASE = '/admin';

export enum AdminRoute {
  PARTNERS = '/partneri',
  LISTINGS = '/sludinajumi',
  LISTING_APPLICATIONS = '/sludinajumi/:listingId/pieteikumi',
  CHAT = '/sarakste',
  TRANSACTIONS = '/darijumi',
  FARM_TRANSACTIONS = '/saimnieciba/darijumi',
  QMARK = '/kvalitates-zimes',
  COUPONS = '/kuponi',
  ESHOP_EMAIL = '/e-veikala-epasti',
  FARM_EMAIL = '/saimniecibu-epasti',
  CONTRACTS = '/ligumi',
  ORDERS = '/pasutijumi',
  FARMS = '/saimniecibas',
  NOTIFICATIONS = '/pazinojumi',
  FARM_USERS = '/saimnieciba/lietotaji',
  FARM_CONTRACTS = '/saimnieciba/ligumi',
  USERS = '/lietotaji',
  PAGES = '/lapas',
  PRODUCTS = '/produkti',
  QUALITY_MARKS = '/kvalitates-zimju-sinhronizacija',
  BANNERS = '/baneri',
  SETTINGS = '/iestatijumi',
  CATALOG_SETTINGS = '/kataloga-iestatijumi',
  EMARKET_SETTINGS = '/e-tirgus-iestatijumi',
  BUSINESS = '/uznemums',
  FARM_DELIVERIES = '/saimnieciba/piegades',
  PERMISSIONS = '/tiesibas',
  CLASSIFIERS = '/klasifikatori',
  ROLES = '/lomas',
}

type Id = string | number | null | undefined;

const toAbsolutePath = (route: AdminRoute) => `${ADMIN_BASE}${route}`;

export const adminPath = {
  base: () => ADMIN_BASE,
  to: (route: AdminRoute) => toAbsolutePath(route),
  roles: () => toAbsolutePath(AdminRoute.ROLES),
  listings: () => toAbsolutePath(AdminRoute.LISTINGS),
  listingApplications: (listingId: Id) =>
    `${ADMIN_BASE}${AdminRoute.LISTINGS}/${listingId}/pieteikumi`,
  notifications: () => toAbsolutePath(AdminRoute.NOTIFICATIONS),
  chat: () => toAbsolutePath(AdminRoute.CHAT),
  farmTransactions: () => toAbsolutePath(AdminRoute.FARM_TRANSACTIONS),
  farmContracts: () => toAbsolutePath(AdminRoute.FARM_CONTRACTS),
  business: () => toAbsolutePath(AdminRoute.BUSINESS),
};

export default AdminRoute;
